<template>
  <div class="container">
    <HeadingOne class="-margin-md">ご本人さま確認書類のご提出</HeadingOne>

    <ErrorsAlert :errors="errors"></ErrorsAlert>

    <slot name="wizard"></slot>

    <section>
      <HeadingThree class="_mt-sm-40 _mt-md-60"
        >アップロード前にご確認ください</HeadingThree
      >
      <p>以下の場合は、再提出が必要となりますのでご注意ください。</p>
      <ListGroup class="-normal _mb-sm-30 _mb-md-50">
        <ListItem class="-normal"
          >画像が極端に小さい、切れている、ぼやけている</ListItem
        >
        <ListItem class="-normal"
          >本籍地、個人番号（マイナンバー）、健康保険証の保険者番号・記号・番号（介護保険の被保険者証および自衛官診療証を含む）、臓器提供意思などが記載されており紙などで隠されていない状態</ListItem
        >
      </ListGroup>

      <HeadingTwo>{{ displayIdentityLabel(identity) }}</HeadingTwo>
      <div class="row _mb-sm-40 _mb-md-60">
        <div
          v-if="!!userData.file_data1"
          class="col-12 col-md-6 _mb-sm-30 _mb-md-50"
        >
          <HeadingThree>{{ displayFile1Label(identity) }}</HeadingThree>
          <ConfirmImage
            :file-name="userData.file_name1"
            :file-data="userData.file_data1"
          ></ConfirmImage>
        </div>
        <div
          v-if="identity !== '05' && !!userData.file_data2"
          class="col-12 col-md-6 _mb-sm-30 _mb-md-50"
        >
          <HeadingThree>{{ displayFile2Label(identity) }}</HeadingThree>
          <ConfirmImage
            :file-name="userData.file_name2"
            :file-data="userData.file_data2"
          ></ConfirmImage>
        </div>
      </div>
      <div
        v-if="
          !!userData.file_data1 || (identity !== '05' && !!userData.file_data2)
        "
        class="_mb-sm-40 _mb-md-60"
      >
        <BtngroupSingle class="-margin-lg">
          <BtnBack class="-back -md" @click.prevent="goBack('#identity')">
            修正する
          </BtnBack>
        </BtngroupSingle>
      </div>
      <div>
        <HeadingTwo>{{
          displaySecondIdentityLabel(secondIdentity)
        }}</HeadingTwo>
        <div class="row _mb-sm-40 _mb-md-60">
          <div v-if="!!userData.file_data3" class="col-12 col-md-6">
            <HeadingThree>{{
              displaySecondFile1Label(secondIdentity)
            }}</HeadingThree>
            <ConfirmImage
              :file-name="userData.file_name3"
              :file-data="userData.file_data3"
            ></ConfirmImage>
          </div>
          <div
            v-if="secondIdentity !== '05' && !!userData.file_data4"
            class="col-12 col-md-6 _mb-sm-30 _mb-md-50"
          >
            <HeadingThree>{{
              displaySecondFile2Label(secondIdentity)
            }}</HeadingThree>
            <ConfirmImage
              :file-name="userData.file_name4"
              :file-data="userData.file_data4"
            ></ConfirmImage>
          </div>
        </div>
      </div>
      <div
        v-if="
          !!userData.file_data3 || (identity !== '05' && !!userData.file_data4)
        "
        class="_mb-sm-40 _mb-md-60"
      >
        <BtngroupSingle class="-margin-lg">
          <BtnBack class="-back -md" @click.prevent="goBack('#secondIdentity')">
            修正する
          </BtnBack>
        </BtngroupSingle>
      </div>
      <div
        v-if="
          nationality === '02' &&
          (proofNationality === '03' || proofNationality === '04')
        "
      >
        <HeadingTwo>{{
          displayProofNationalityLabel(proofNationality)
        }}</HeadingTwo>
        <div class="row _mb-sm-40 _mb-md-60">
          <div
            v-if="!!userData.file_data5"
            class="col-12 col-md-6 _mb-sm-30 _mb-md-50"
          >
            <HeadingThree>{{
              displayFile4Label(proofNationality)
            }}</HeadingThree>
            <ConfirmImage
              :file-name="userData.file_name5"
              :file-data="userData.file_data5"
            ></ConfirmImage>
          </div>
          <div
            v-if="!!userData.file_data6"
            class="col-12 col-md-6 _mb-sm-30 _mb-md-50"
          >
            <HeadingThree>{{
              displayFile5Label(proofNationality)
            }}</HeadingThree>
            <ConfirmImage
              :file-name="userData.file_name6"
              :file-data="userData.file_data6"
            ></ConfirmImage>
          </div>
        </div>
        <div
          v-if="!!userData.file_data5 || !!userData.file_data6"
          class="_mb-sm-40 _mb-md-60"
        >
          <BtngroupSingle class="-margin-lg">
            <BtnBack
              class="-back -md"
              @click.prevent="goBack('#proofNationality')"
            >
              修正する
            </BtnBack>
          </BtngroupSingle>
        </div>
      </div>

      <form
        v-if="topPageId === 'en007'"
        onmousedown="dlpoloan_honninkakuninshoruiteishutsuClickCv()"
        @submit.prevent="submitIdentifyFile"
      >
        <BtngroupSingle class="_mb-sm-40">
          <BtnMain class="-main" @click.prevent="submitIdentifyFile">
            この内容でアップロードする
          </BtnMain>
        </BtngroupSingle>
      </form>

      <form
        v-if="topPageId === 'en026'"
        onmousedown="dlpoloan_sai_honninkakuninshoruiteishutsuClickCv()"
        @submit.prevent="submitIdentifyFile"
      >
        <BtngroupSingle class="_mb-sm-40">
          <BtnMain class="-main" @click.prevent="submitIdentifyFile">
            この内容でアップロードする
          </BtnMain>
        </BtngroupSingle>
      </form>

      <form
        v-if="topPageId !== 'en007' && topPageId !== 'en026'"
        @submit.prevent="submitIdentifyFile"
      >
        <BtngroupSingle class="_mb-sm-40">
          <BtnMain class="-main" @click.prevent="submitIdentifyFile">
            この内容でアップロードする
          </BtnMain>
        </BtngroupSingle>
      </form>

      <BtngroupSingle class="-margin-lg">
        <BtnBack class="-back -md" @click.prevent="goTop">
          書類を選択し直す
        </BtnBack>
      </BtngroupSingle>
    </section>
  </div>
</template>

<script>
import { goToErrorPage, scrollTop } from "@/utils/Other";
import { initCredentials } from "@/utils/Auth";
import {
  getUserDataLambdaInvoke,
  submitIdentifyFileLambdaInvoke,
} from "@/utils/LambdaHelper";
import {
  fileUploadCreated,
  displayIdentityLabel,
  displayFile1Label,
  displayFile2Label,
  displaySecondFile1Label,
  displaySecondFile2Label,
  displaySubIdentityLabel,
  displaySecondIdentityLabel,
  displayProofNationalityLabel,
  displayFile4Label,
  displayFile5Label,
  setPersonalConfirmImageAtCookie,
} from "@/utils/FileUpload";

import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import HeadingThree from "@/components/heading/HeadingThree";
import ConfirmImage from "@/components/upload/ConfirmImage";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import ErrorsAlert from "@/components/alert/ErrorsAlert";

export default {
  name: "IdentifyDblConfirm",
  components: {
    ErrorsAlert,
    BtnBack,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    ConfirmImage,
    HeadingThree,
    HeadingTwo,
    HeadingOne,
  },
  props: {
    topPageId: { type: String, default: "" },
    previousPageId: { type: String, default: "" },
    nextPageId: { type: String, default: "" },
  },
  setup() {
    return {
      fileUploadCreated,
      displayIdentityLabel,
      displayFile1Label,
      displayFile2Label,
      displaySecondFile1Label,
      displaySecondFile2Label,
      displaySubIdentityLabel,
      displaySecondIdentityLabel,
      displayProofNationalityLabel,
      displayFile4Label,
      displayFile5Label,
      setPersonalConfirmImageAtCookie,
    };
  },
  data() {
    return {
      errors: null,
      identity: this.$route.query.identity,
      secondIdentity: this.$route.query.secondIdentity,
      nationality: this.$route.query.nationality,
      proofNationality: this.$route.query.proofNationality,
      isDisabled: false,
      files: true,
      userData: {
        processing_type: "1",
        file_name1: "",
        file_data1: "",
        file_name2: "",
        file_data2: "",
        file_name3: "",
        file_data3: "",
        file_name4: "",
        file_data4: "",
        file_name5: "",
        file_data5: "",
        file_name6: "",
        file_data6: "",
      },
    };
  },
  created() {
    this.fileUploadCreated();
    this.checkQueryParam();
  },
  mounted() {
    try {
      getUserDataLambdaInvoke(this.files)
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitIdentifyFile() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        this.checkQueryParam();
        initCredentials()
          .then(() => {
            submitIdentifyFileLambdaInvoke()
              .then((res) => {
                this.errors = res.errors || {};
                if (Object.keys(this.errors).length > 0) {
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  this.setPersonalConfirmImageAtCookie();
                  this.$router.push({ name: this.nextPageId });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    checkQueryParam() {
      try {
        if (
          window.__PRERENDER_INJECTED &&
          window.__PRERENDER_INJECTED.isPrerendering
        ) {
          // ビルド時の静的ファイル生成時はチェックしない
          return;
        }
        if (
          ["01", "02", "03", "04", "05"].indexOf(this.$route.query.identity) ===
          -1
        ) {
          this.$router.push({ name: this.topPageId });
        }
        if (
          ["01", "02", "03", "04", "05", "06", "07"].indexOf(
            this.$route.query.secondIdentity
          ) === -1
        ) {
          this.$router.push({ name: this.topPageId });
        }
        if (["01", "02"].indexOf(this.$route.query.nationality) === -1) {
          this.$router.push({ name: this.topPageId });
        }
        if (["02"].indexOf(this.$route.query.nationality) !== -1) {
          if (["03", "04"].indexOf(this.$route.query.proofNationality) === -1) {
            this.$router.push({ name: this.topPageId });
          }
        }
      } catch (e) {
        goToErrorPage(e);
      }
    },
    goBack: function (hash) {
      try {
        let queryParam = {
          identity: this.identity || "00",
          secondIdentity: this.secondIdentity || "00",
          nationality: this.nationality || "02",
          proofNationality: this.proofNationality || "00",
        };
        this.$router.push({
          name: this.previousPageId,
          query: queryParam,
          hash: hash,
        });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    goTop: function () {
      try {
        let queryParam = {
          identity: this.identity || "00",
          secondIdentity: this.secondIdentity || "00",
          nationality: this.nationality || "02",
          proofNationality: this.proofNationality || "00",
        };
        this.$router.push({ name: this.topPageId, query: queryParam });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style scoped></style>
